export class AnimaError extends Error {
  // Marker to check at runtime if this, or its children, are an Anima SDK error
  __ANIMA_SDK_ERROR: boolean = true;

  constructor(message: string) {
    super(message);
    this.name = 'AnimaError';
  }
}

export class AnimaBadRequestError extends AnimaError {
  constructor(message: string = 'Bad Request') {
    super(message);
    this.name = 'AnimaBadRequestError';
  }
}

export class AnimaUnauthorizedError extends AnimaError {
  constructor(message: string = 'Unauthorized') {
    super(message);
    this.name = 'AnimaUnauthorizedError';
  }
}

export class AnimaForbiddenError extends AnimaError {
  constructor(message: string = 'Forbidden') {
    super(message);
    this.name = 'AnimaForbiddenError';
  }
}

export class AnimaNotFoundError extends AnimaError {
  constructor(message: string = 'Not Found') {
    super(message);
    this.name = 'AnimaNotFoundError';
  }
}

export class AnimaInternalServerError extends AnimaError {
  constructor(message: string = 'Internal Server Error') {
    super(message);
    this.name = 'AnimaInternalServerError';
  }
}

export class AnimaConflictError extends AnimaError {
  constructor(message: string = 'Conflict') {
    super(message);
    this.name = 'AnimaConflictError';
  }
}

export class AnimaUnknownError extends AnimaError {
  constructor(message: string = 'Unknown Error') {
    super(message);
    this.name = 'AnimaUnknownError';
  }
}

export async function raiseIfResponseError(response: Response): Promise<void> {
  if (response.status === 400) {
    const error = await parseErrorMessage(response);
    throw new AnimaBadRequestError(error);
  } else if (response.status === 401) {
    const error = await parseErrorMessage(response);
    throw new AnimaUnauthorizedError(error);
  } else if (response.status === 403) {
    const error = await parseErrorMessage(response);
    throw new AnimaForbiddenError(error);
  } else if (response.status === 404) {
    const error = await parseErrorMessage(response);
    throw new AnimaNotFoundError(error);
  } else if (response.status === 409) {
    const error = await parseErrorMessage(response);
    throw new AnimaConflictError(error);
  } else if (response.status === 500) {
    const error = await parseErrorMessage(response);
    throw new AnimaInternalServerError(error);
  } else if (response.status >= 400) {
    const error = await parseErrorMessage(response);
    throw new AnimaUnknownError(error);
  }
}

async function parseErrorMessage(response: Response): Promise<string | undefined> {
  try {
    const json = await response.json();
    if (json && typeof json.error === 'string') {
      return json.error;
    }
  } catch {
    // Ignore JSON parsing errors
  }
  return undefined;
}
